import { Accordion, IAccordionData } from '../Accordion/Accordion';
import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';
import { Container } from '../Container/Container';
import { Heading, HeadingVariant } from '../Heading/Heading';
import { twMerge } from 'tailwind-merge';
import { getFAQMetaData } from './helpers/getFAQMetaData';
import { FAQSchema } from './components/FAQSchema/FAQSchema';
import { ZENDESK_HELP_CENTER_URL } from '@config/zendesk';
import { ReactNode } from 'react';

export type IFAQData = IAccordionData & { bodyString?: string };

interface IProps {
  children?: ReactNode;
  className?: string;
  faqData: IFAQData[];
  headingVariant?: HeadingVariant;
  id?: string;
  showFAQMetaData?: boolean;
  showMoreFAQ?: boolean;
  title?: string;
}

export const FAQ = ({
  children,
  className,
  faqData,
  headingVariant = 'xl',
  id,
  showFAQMetaData = true,
  showMoreFAQ = false,
  title = 'FAQ',
}: IProps) => {
  const faqMetaData = showFAQMetaData ? getFAQMetaData(faqData) : [];

  return (
    <Container className={twMerge('py-8', className)} id={id} data-testid="FAQSection">
      {showFAQMetaData && <FAQSchema faqMetaData={faqMetaData} />}
      <div className="sm:w-col-10 md:w-col-6 flex flex-col gap-8 sm:mx-auto">
        <Heading variant={headingVariant} className="text-center">
          {title}
        </Heading>
        <div className="flex flex-col gap-4">
          <Accordion
            blocksData={faqData}
            className="bg-lake-fog"
            contentClassName="body-text-sm pt-0"
          />
        </div>
        {showMoreFAQ && (
          <div className="mt-4 text-center text-lg">
            <ExternalLink variant="buttonTertiary" href={ZENDESK_HELP_CENTER_URL}>
              More FAQ
            </ExternalLink>
          </div>
        )}
        {children}
      </div>
    </Container>
  );
};
